import { SearchCategory, SearchProps } from './_GlobalSearch';
import { prependSlash } from '@repo/ui/src/components/Anchor/helpers';
import SearchIcon from '@repo/ui/src/components/Icons/SearchIcon';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import classNames from 'classnames';
import React from 'react';

const getSearchTerm = (form: HTMLFormElement) => new FormData(form).get('searchTerm') as string;

const DropdownSearch = ({
  link = 'search',
  placeholder = 'Search',
  searchCategory = SearchCategory.all,
}: SearchProps) => {
  const { push } = useCurrentUrl();
  const ref = React.useRef<HTMLInputElement>(null);

  const handleSearch = async (term: string) => {
    const queryParams = new URLSearchParams({
      term,
    });
    if (searchCategory !== SearchCategory.all) {
      queryParams.set('type', searchCategory);
    }
    const url = `${prependSlash(link)}?${queryParams}`;
    await push(url);
    ref.current!.value = '';
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        return handleSearch(getSearchTerm(e.currentTarget));
      }}
      className="relative text-neutral-600 pb-1"
    >
      <label htmlFor="searchTerm" className="sr-only">
        {placeholder}
      </label>
      <SearchIcon className="absolute inset-y-3 left-6 text-neutral-600 w-6" decorative />
      <input
        type="text"
        name="searchTerm"
        placeholder={placeholder}
        autoComplete="off"
        className={classNames(
          'rounded-[80px] bg-warm-200 border border-neutral-300 py-3 pl-15 pr-4 tra-text-web-body-l placeholder:text-neutral-600 focus:outline-brand-200 focus:outline-2 focus-visible:outline w-full',
        )}
        ref={ref}
      />
    </form>
  );
};

export default DropdownSearch;
